import { getContext } from 'configs/context';

const isUserAuthorized = () => Boolean(getContext().general.auth.getState().id);

export default isUserAuthorized;
